import React, { ReactNode } from "react";
import { Modal } from "react-bootstrap";
import { StringWithFormat } from "../../types/Result";
import { Translate } from "../Translate";

interface IPopupProps {
    title: string | StringWithFormat
    show: boolean
    onHide: () => void
    size?: 'sm' | 'lg' | 'xl' | 'xxl';
    children: any
}

interface IBodyProps {
    children: ReactNode | ReactNode[];
}

interface IFooterProps {
    children: ReactNode | ReactNode[];
}

const Popup = (props: IPopupProps) => {
    let subComponentList = Object.keys(Popup)
    let subComponents = subComponentList.map((key) => {
        return React.Children.map(props.children, (child) => {
            if (child && child.type)
                return child.type._type === key ? child : null
        });
    });

    let titleToken = 'Popup-Title: ';
    if (typeof props.title === 'string')
        titleToken += props.title
    else
        titleToken += props.title.format

    let size: 'sm' | 'lg' | 'xl' | undefined
    if (props.size === 'xxl')
        size = 'xl'
    else
        size = props.size

    let dialogClassName = 'popup-' + props.size

    return (
        <Modal show={props.show} onHide={props.onHide} size={size} dialogClassName={dialogClassName}>
            <Modal.Header closeButton>
                <Modal.Title><Translate token={titleToken}>{props.title}</Translate></Modal.Title>
            </Modal.Header>
            {subComponents.map((component) => component)}
        </Modal>
    );
}

const Body = (props: IBodyProps) => <Modal.Body>{props.children}</Modal.Body>;
Body._type = 'Body'
Popup.Body = Body;

const Footer = (props: IFooterProps) => <Modal.Footer>{props.children}</Modal.Footer>;
Footer._type = 'Footer'
Popup.Footer = Footer;

export default Popup;
